import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface FormAssetClassMappingListGridActionCellRendererParams extends ICellRendererParams {
    viewDepreciationTable: (params: FormAssetClassMappingListGridActionCellRendererParams) => void;
    canViewDepreciationTable: (params: FormAssetClassMappingListGridActionCellRendererParams) => boolean;
}

@Component({
    selector: 'form-asset-class-mapping-grid-action-cell',
    template: `
    @if (params.data) {
      <button class="ace-btn has-icon btn-secondary grid-action-button" title="View depreciation table" [disabled]="!params.canViewDepreciationTable(params)" (click)="params.viewDepreciationTable(params)">
        <i class="fa fa-external-link"></i>
      </button>
    }
    `,
    standalone: false
})
export class FormAssetClassMappingListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: FormAssetClassMappingListGridActionCellRendererParams;

    agInit(params: FormAssetClassMappingListGridActionCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
